import NumericCellEditor from './NumericCellEditor';

class PercentageCellEditor extends NumericCellEditor {
  afterGuiAttached() {
    this.eInput.focus();
    this.eInput.select();
    this.eInput.value = this.eInput.value ? this.eInput.value * 100 : '';
  }
}

export default PercentageCellEditor;
